<template><v-expansion-panels v-bind="$attrs" class="base-expansion-panels vuetify"><slot></slot></v-expansion-panels></template>

<script>
export default {
    name: 'BaseExpansionPanels'
};
</script>